import "./CompanyPartner.css";

import hubspot from "../../assets/Frame (1).svg";
import netflix from "../../assets/Frame (2).svg";
import lacoste from "../../assets/Frame (3).svg";
import postclick from "../../assets/Frame (4).svg";
import remote from "../../assets/Frame (5).svg";
import brex from "../../assets/Frame (6).svg";

const CompanyPartner = () => {
  return (
    <section className="trusted-by-partners-section">
      <div className="container">
        <div className="trusted-by-partners-wrapper">
          <h2>Trusted by Industry leading Enterprises</h2>
          <div className="trusted-by-partners-images row">
            <div className="col-3 col-sm-2 col-md-2 col-lg-1 partners-icon-col">
              <img src={hubspot} alt="hubspot" loading="lazy"/>
            </div>
            <div className="col-3 col-sm-2 col-md-2 col-lg-1 partners-icon-col">
              <img
                src={netflix}
                alt="netflix"
                loading="lazy"
                width="140"
                height="27"
              />
            </div>
            <div className="col-3 col-sm-2 col-md-2 col-lg-1 partners-icon-col">
              <img src={lacoste} alt="lacoste" loading="lazy" />
            </div>
            <div className="col-3 col-sm-2 col-md-2 col-lg-1 partners-icon-col">
              <img src={postclick} alt="postclick" loading="lazy" />
            </div>
            <div className="col-3 col-sm-2 col-md-2 col-lg-1 partners-icon-col">
              <img src={brex} alt="brex" loading="lazy" />
            </div>
            <div className="col-3 col-sm-2 col-md-2 col-lg-1 partners-icon-col">
              <img src={remote} alt="remote" loading="lazy" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CompanyPartner;
